import Vue from 'vue'

export const fetchContacts = ({ commit, getters }) => {
    return Vue.prototype.$rest.get("/user/" + getters.getTargetContext.id + "/contact").then(function (content) {
        commit("setContacts", content.data)
    })
};

export const fetchContact = ({ getters, commit }) => {
    return Vue.prototype.$rest.get("/user/" + getters.getTargetContext.id + "/contact").then(function (content) {
        commit("setContacts", content.data)
    })
};

export const deleteContact = ({getters, commit}, id) => {
    return Vue.prototype.$rest.delete("/user/" + getters.getTargetContext.id + "/contact/" + id).then(function (content) {
        commit("removeContact", id)
    })
};

export const updateContact = ({getters, commit}, contact) => {
    let {id, ...data} = contact;

    return Vue.prototype.$rest.put("/user/" + getters.getTargetContext.id + "/contact/" + id, data).then(function (content) {
        commit("updateContact", contact)
    })
};

/*export const assignContact = ({getters, commit}, contact, sensor) => {
    let {id, ...data} = contact;

    return Vue.prototype.$rest.put("/user/" + getters.getTargetContext.id + "/contact/" + id, data).then(function (content) {
        commit("updateContact", contact)
    })
};*/


// WEBPACK FOOTER //
// ./src/store/actions/contacts.js